module.exports = __webpack_public_path__ + "img/alchemille.eea0c416.jpg";